import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import { Button, ButtonType } from '../Button';
import { Modal } from '../Modal';

// Angular source: apps/angular/src/js/ng/parent/bookings/add-details/add-details.tpl.html
// Shown when agency services are unavailable in the requested location.
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSearch: () => void;
}

export const AgencyErrorModal = ({ isOpen, onClose, onSearch }: Props): JSX.Element => (
  <Modal isOpen={isOpen} onClose={onClose} className='w-full max-w-md'>
    <Button
      aria-label='Close'
      onClick={onClose}
      className='absolute right-2 top-2 text-gray-400 hover:text-gray-500 transition-colors'
    >
      <FontAwesomeIcon icon={faXmark} className='w-5 h-5' />
    </Button>
    <h4 className='font-semibold mb-2'>Oops</h4>
    <p className='mb-4'>
      We&apos;re sorry, agency services are not available in this location. Browse
      caregivers that match your job instead.
    </p>
    <div className='text-right'>
      <Button buttonType={ButtonType.secondary} className='mr-2' onClick={onClose}>
        Cancel
      </Button>
      <Button buttonType={ButtonType.primary} onClick={onSearch}>
        Search
      </Button>
    </div>
  </Modal>
);
